import type { PlatformRole } from '@vlm/api';
import { Building2, FileText, Layers, LayoutDashboard, Landmark, Mail, UserCog, type LucideIcon } from 'lucide-react';
import type { Key } from '../i18n';
import { ADMINS } from '../lib/auth';

export interface NavItem {
  to: string;
  label: Key;
  icon: LucideIcon;
  /** Who sees it; every platform user when absent. The API enforces the same rules. */
  roles?: readonly PlatformRole[];
}

/** The rail: the day's work first (who is waiting, who pays), then what is set up once. */
export const NAV: NavItem[] = [
  { to: '/overview', label: 'nav.dashboard', icon: LayoutDashboard },
  { to: '/companies', label: 'nav.companies', icon: Building2 },
  { to: '/invoices', label: 'nav.invoices', icon: FileText },
  { to: '/plans', label: 'nav.plans', icon: Layers },
  { to: '/settings/billing', label: 'nav.billing', icon: Landmark },
  { to: '/settings/email', label: 'nav.email', icon: Mail },
  { to: '/users', label: 'nav.users', icon: UserCog, roles: ADMINS },
];

export const visibleNav = (role: PlatformRole | undefined) => NAV.filter((item) => !item.roles || (role !== undefined && item.roles.includes(role)));
